import usePageTitle from '../hooks/usePageTitle';
import { ManagementSkills } from '../data/managementSkills';

import("../styles/management.scss");

function Management() {
  usePageTitle('Management | Dochano')
  return (
    <section id="Management">
      <div id="Intro">
          <h1>Management</h1>
      </div>

      <div className="flex">
          {
            ManagementSkills.map((skillItem, index) => (
              <div key={skillItem.title}>
                {skillItem.image && (
                  <figure>
                    <img src={skillItem.image} alt={skillItem.title} width="139" height="186" />
                    <figcaption>Fig.{index + 1} - {skillItem.catchPhrase}</figcaption>
                  </figure>
                )}
                <h3>{skillItem.title}</h3>
                <p>{skillItem.description}</p>
              </div>
            ))
          }
      </div>
    </section>
  );
}

export default Management;